import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { BaseService } from 'src/app/system-common/services/base.service';
import { ProductionService } from '../services/production.service';
import { ProductionDetailsSearchHandler } from './production-details-search.handler';

@Component({
  selector: 'sym-production-details-search',
  templateUrl: './production-details-search.component.html',
  styleUrls: ['./production-details-search.component.scss'],
})
export class ProductionDetailsSearchComponent extends ProductionDetailsSearchHandler {
  constructor(
    public service: ProductionService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
